import lowerCase from 'lodash/lowerCase';
import { USER, type UserAction } from '../actions/userActions';

export type UserState = {
  subscription: string | null;
  role: string | null;
  subscriptionState: string | null;
  accountCode: string | null;
  userId: string | null;
  skipABox: boolean;
  fetchingUserStatus: boolean;
  userAvatarUrl: string;
  fetchingUserAvatar: boolean;
  isAccountPastDue: boolean;
  fetchingIsAccountPastDue: boolean;
  userStatusError: boolean;
};

export const userInitialState = {
  subscription: null,
  role: null,
  subscriptionState: null,
  accountCode: null,
  userId: null,
  skipABox: false,
  fetchingUserStatus: true,
  userAvatarUrl: null,
  fetchingUserAvatar: false,
  isAccountPastDue: false,
  isAccountPastDueRefetch: null,
  fetchingIsAccountPastDue: false,
  userStatusError: false,
};

export function userReducer(state = userInitialState, action: UserAction): UserState {
  switch (action.type) {
    case USER.RECEIVE_USER_STATUS: {
      return {
        ...state,
        ...action.payload,
        subscription: lowerCase(action.payload.subscription),
        role: lowerCase(action.payload.role),
        fetchingUserStatus: false,
      };
    }
    case USER.RECEIVE_USER_ERROR: {
      return {
        ...state,
        fetchingUserStatus: false,
        userStatusError: true,
      };
    }
    case USER.FETCH_USER_AVATAR_REQUEST: {
      return {
        ...state,
        fetchingUserAvatar: true,
      };
    }
    case USER.FETCH_USER_AVATAR_SUCCESS: {
      return {
        ...state,
        fetchingUserAvatar: false,
        userAvatarUrl: action.userAvatarUrl,
      };
    }
    case USER.FETCH_USER_AVATAR_FAILURE: {
      return {
        ...state,
        fetchingUserAvatar: false,
        error: action.error,
      };
    }
    case USER.REQUEST_ACCOUNT_PAST_DUE: {
      return {
        ...state,
        fetchingIsAccountPastDue: true,
      };
    }
    case USER.RECEIVE_ACCOUNT_PAST_DUE_SUCCESS: {
      return {
        ...state,
        fetchingIsAccountPastDue: false,
        isAccountPastDueRefetch: action.isAccountPastDue,
      };
    }
    case USER.RECEIVE_ACCOUNT_PAST_DUE_ERROR: {
      return {
        ...state,
        fetchingIsAccountPastDue: false,
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
}

export default userReducer;
